import { Socio } from './Socio';

export class SocioDependente{
    id = 0;
    foto = '';
    status = 0;
    nome = '';
    dataCadastro =  new Date();
    nascimento =  new Date();
    cpf = '';
    matricula = '';
    graduacao = '';
    tipo = '';
    usoClube = '';
    idGraduacao = 0;
    socioTitular = '';
    idSocio = 0;
    socio = new Socio();
    matriculaTitular = '';
    tipoSocio = '';
    idade = 0;
    telefone = '';
    pessoa: any;
}